import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-circle-skeleton',
  templateUrl: './circle-skeleton.component.html',
  styleUrls: ['./circle-skeleton.component.css']
})
export class CircleSkeletonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
